import React from "react";
import { makeStyles, Typography } from "@material-ui/core";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";
import Badge from "@material-ui/core/Badge";
import ChatIcon from "@material-ui/icons/Chat";
var useStyles = makeStyles(function (theme) {
  return {
    container: {
      display: "flex",
      alignItems: "center"
    },
    nameContainer: {
      display: "flex",
      flex: "1"
    },
    name: {
      "&:hover": {
        color: theme.palette.primary.main
      },
      marginLeft: "15px"
    },
    iconContainer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    },
    chatIcon: {
      color: theme.palette.text.primary
    }
  };
});

var ChatItem = function ChatItem(props) {
  // console.log("ChatItem", props);
  var classes = useStyles();
  return /*#__PURE__*/React.createElement("div", {
    className: [classes.container, props.classes].join(" "),
    onClick: function onClick() {
      // console.log("chat item clicked", props.room, props.type);
      props.handleClick(props.room, props.type, props.name);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.nameContainer
  }, props.unread ? /*#__PURE__*/React.createElement(Badge, {
    color: "primary" // style={{ color: "#77ffb5" }}
    // badgeContent={" "}
    ,
    variant: "dot",
    anchorOrigin: {
      vertical: "top",
      horizontal: "right"
    }
  }, props.direct && /*#__PURE__*/React.createElement(ChatIcon, {
    className: classes.chatIcon
  })) : props.direct && /*#__PURE__*/React.createElement(ChatIcon, {
    className: classes.chatIcon
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    className: classes.name
  }, props.name.length > 35 ? "".concat(props.name.substring(0, 30), "...") : props.name)), /*#__PURE__*/React.createElement("div", {
    className: classes.iconContainer
  }, /*#__PURE__*/React.createElement(KeyboardArrowRightIcon, {
    fontSize: "large"
  })));
};

export { ChatItem };